import { jsx as _jsx } from "theme-ui/jsx-runtime";
import React from 'react';
export const Box = React.forwardRef((props, ref) => (_jsx("div", Object.assign({}, props, { ref: ref }))));
